import type { IPhysicianNetwork } from '@care-portals/api-interfaces';

export const PHYSICIAN_NETWORKS: readonly IPhysicianNetwork[] = [
  { name: 'Beluga', key: 'beluga' },
  { name: 'MDI', key: 'mdi' },
  { name: 'Arora', key: 'arora' }
] as const;
